import React from "react";
import { ModalBuilder, Table } from "@redriver/cinnamon";
import { TranslatedModal } from "../../../components/modals";

const RemoveRateGroupModal = ({ submitAction, onSubmitted, rateGroup }) => (
  <ModalBuilder
    submitAction={submitAction}
    submitParams={rateGroup.id}
    onSubmitted={onSubmitted}
    renderTrigger={(showModal) => (
      <Table.MenuItem onClick={showModal}>Delete</Table.MenuItem>
    )}
    renderModal={(modalProps) => (
      <TranslatedModal.Delete
        {...modalProps}
        header="Remove Rate Group"
        submitLabel="Remove Rate Group"
      >
        <p>Are you sure you wish to remove '{rateGroup.name}'?</p>
      </TranslatedModal.Delete>
    )}
  />
);

export default RemoveRateGroupModal;
